(() => {
  const MODULE_KEY = '__alphaCollectionUx';
  if (window[MODULE_KEY]) return;
  window[MODULE_KEY] = true;

  const defaultUiText = {
    imageFormat: 'Card layout',
    format: 'Card layout',
    auto: 'Auto',
    portrait: 'Portrait',
    square: 'Square',
    landscape: 'Landscape',
    loadingMore: 'More artworks load automatically',
    allDisplayed: 'The entire collection is displayed',
    retryLoading: 'Retry loading',
    productPreview: 'Product preview',
    close: 'Close',
    view: 'View',
    slideshowFromHere: 'Slideshow from here',
    compareArtworks: 'Compare artworks',
    compare: 'Compare',
    clear: 'Clear',
    artwork: 'artwork',
    artworks: 'artworks',
    toCompare: 'to compare',
    remove: 'Remove',
    of: 'of',
    loading: 'Loading…',
    scrollForMore: 'Scroll to see more',
    resume: 'Resume where I left off',
  };
  const frenchUiText = {
    imageFormat: 'Mise en page',
    format: 'Mise en page',
    auto: 'Auto',
    portrait: 'Portrait',
    square: 'Carré',
    landscape: 'Large',
    loadingMore: 'La suite se charge automatiquement',
    allDisplayed: 'Toute la collection est affichée',
    retryLoading: 'Réessayer le chargement',
    productPreview: 'Aperçu produit',
    close: 'Fermer',
    view: 'Voir',
    slideshowFromHere: 'Diaporama à partir d’ici',
    compareArtworks: 'Comparer les œuvres',
    compare: 'Comparer',
    clear: 'Vider',
    artwork: 'œuvre',
    artworks: 'œuvres',
    toCompare: 'à comparer',
    remove: 'Retirer',
    of: 'sur',
    loading: 'Chargement…',
    scrollForMore: 'Faites défiler pour voir la suite',
    resume: 'Reprendre où j’étais',
  };
  const labelsNode = document.querySelector('[data-alpha-collection-labels]');
  let uiText = defaultUiText;
  if (labelsNode) {
    try {
      uiText = { ...defaultUiText, ...JSON.parse(labelsNode.textContent || '{}') };
    } catch (_error) {
      uiText = defaultUiText;
    }
  }
  if (String(document.documentElement.lang || '').toLowerCase().startsWith('fr')) {
    uiText = { ...uiText, ...frenchUiText };
  }

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  };

  ready(() => {
    const resultsList = document.querySelector('results-list.product-grid-container');
    const grid = document.querySelector('.product-grid');
    if (!resultsList || !grid) return;

    const state = {
      compare: readList('alphaCollectionCompare:v1').slice(0, 4),
      preloaded: new Set(),
    };

    keepDefaultGridView(grid);

    const resumeKey = `alphaCollectionResume:${window.location.pathname}`;
    const ui = createCollectionBar(resultsList, grid);
    ui?.classList.toggle('is-infinite', resultsList.getAttribute('infinite-scroll') === 'true');
    initRatioControl(ui, grid);
    initResilientInfiniteScroll(resultsList, grid, ui);
    const quickView = createQuickView();
    const compareDrawer = createCompareDrawer(state);
    const resumeButton = createResumeButton(resumeKey);

    removeDuplicateProducts(grid);
    enhanceCards();
    updateCounter(ui, resultsList, grid);
    renderCompare(compareDrawer, state);
    markLoadedImages();

    const observer = new MutationObserver(() => {
      removeDuplicateProducts(grid);
      enhanceCards();
      updateCounter(ui, resultsList, grid);
      markLoadedImages();
    });
    observer.observe(grid, { childList: true, subtree: true });

    wireResumeStorage(resumeKey);
    

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const action = target.closest('[data-alpha-ux-action]');
      if (!action) return;

      const card = action.closest('[data-alpha-product-card]');
      const product = readProduct(card);
      if (!product) return;

      const type = action.getAttribute('data-alpha-ux-action');
      if (type === 'quick') {
        event.preventDefault();
        openQuickView(quickView, product);
      }
      if (type === 'slideshow') {
        event.preventDefault();
        openSlideshowAt(product.handle);
      }
      if (type === 'compare') {
        event.preventDefault();
        toggleCompare(product, state);
        renderCompare(compareDrawer, state);
        refreshCompareButtons(state);
      }
    });

    quickView.root.addEventListener('click', (event) => {
      if (event.target === quickView.root || event.target === quickView.close) closeQuickView(quickView);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !quickView.root.hidden) closeQuickView(quickView);
    });

    compareDrawer.clear.addEventListener('click', () => {
      state.compare = [];
      saveList('alphaCollectionCompare:v1', state.compare);
      renderCompare(compareDrawer, state);
      refreshCompareButtons(state);
    });

    compareDrawer.items.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('[data-alpha-compare-remove]');
      if (!button) return;
      const handle = button.getAttribute('data-alpha-compare-remove');
      state.compare = state.compare.filter((item) => item.handle !== handle);
      saveList('alphaCollectionCompare:v1', state.compare);
      renderCompare(compareDrawer, state);
      refreshCompareButtons(state);
    });

    if (resumeButton) {
      resumeButton.addEventListener('click', () => {
        const data = readResume(resumeKey);
        if (!data) return;
        const card = findCardByHandle(data.handle);
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        window.scrollTo({ top: data.scrollY || 0, behavior: 'smooth' });
      });
    }
  });

  function createCollectionBar(resultsList, grid) {
    if (document.querySelector('[data-alpha-collection-ux]')) {
      return document.querySelector('[data-alpha-collection-ux]');
    }

    const bar = document.createElement('div');
    bar.className = 'alpha-collection-ux';
    bar.setAttribute('data-alpha-collection-ux', '');
    bar.innerHTML = `
      <div class="alpha-ratio-control" data-grid-product-controls>
        <label for="AlphaGridProduct">${document.documentElement.lang.startsWith('fr') ? 'Choisissez votre produit' : 'Choose your product'}</label>
        <select id="AlphaGridProduct" class="alpha-ratio-control__button" style="max-width:100%;font-size:15px;min-height:44px" data-grid-product></select>
        <select aria-label="${document.documentElement.lang.startsWith('fr') ? 'Finition' : 'Presentation'}" class="alpha-ratio-control__button" style="max-width:100%;font-size:15px;min-height:44px" data-grid-finish></select>
      </div>
      <div class="alpha-collection-ux__status" data-alpha-collection-status></div>
    `;

    const gridShell = grid.parentElement;
    gridShell?.insertBefore(bar, grid);
    const productSelect = bar.querySelector('[data-grid-product]');
    const finishSelect = bar.querySelector('[data-grid-finish]');
    const selector = () => document.querySelector('.abt[data-browse-page="collection"]');
    const syncProducts = () => {
      const source = selector();
      if (!source) return;
      const types = [...source.querySelectorAll('input[data-browse-type]')];
      productSelect.replaceChildren(...types.map(input => new Option(input.closest('label').querySelector('strong').textContent, input.value, false, input.checked)));
      const selectedType = types.find(input => input.checked)?.value;
      const group = [...source.querySelectorAll('[data-browse-for]')].find(node => node.dataset.browseFor === selectedType);
      finishSelect.replaceChildren(...[...(group?.querySelectorAll('input[data-browse-presentation]') || [])].map(input => {
        const option = new Option(input.closest('label').querySelector('.abt__finish-copy > strong').textContent, input.value, false, input.checked);
        option.disabled = input.disabled;
        return option;
      }));
    };
    productSelect.addEventListener('change', () => {
      const input = [...(selector()?.querySelectorAll('input[data-browse-type]') || [])].find(node => node.value === productSelect.value);
      input?.click();
      syncProducts();
    });
    finishSelect.addEventListener('change', () => {
      const group = [...(selector()?.querySelectorAll('[data-browse-for]') || [])].find(node => node.dataset.browseFor === productSelect.value);
      const input = [...(group?.querySelectorAll('input[data-browse-presentation]') || [])].find(node => node.value === finishSelect.value);
      input?.click();
      syncProducts();
    });
    window.addEventListener('alpha:artwork-browse', syncProducts);
    document.addEventListener('change', event => {
      if (event.target.closest('.abt[data-browse-page="collection"]')) syncProducts();
    });
    syncProducts();
    return bar;
  }

  function initRatioControl(root, grid) {
    const storageKey = 'alphaCollectionRatio:v1';
    let savedRatio = 'auto';

    try {
      savedRatio = localStorage.getItem(storageKey) || savedRatio;
    } catch (_error) {
      savedRatio = 'auto';
    }

    const applyRatio = (ratio) => {
      const safeRatio = ['auto', 'portrait', 'square', 'landscape'].includes(ratio) ? ratio : 'auto';
      grid.setAttribute('data-alpha-ratio', safeRatio);
      root?.querySelectorAll('[data-alpha-ratio]').forEach((button) => {
        button.classList.toggle('is-active', button.getAttribute('data-alpha-ratio') === safeRatio);
        button.setAttribute('aria-pressed', String(button.getAttribute('data-alpha-ratio') === safeRatio));
      });
      try {
        localStorage.setItem(storageKey, safeRatio);
      } catch (_error) {
        // Storage can be unavailable in private or restricted mobile contexts.
      }
    };

    root?.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('[data-alpha-ratio]');
      if (!button) return;
      applyRatio(button.getAttribute('data-alpha-ratio') || 'auto');
    });

    applyRatio(savedRatio);
  }

  function keepDefaultGridView(grid) {
    const forceDefault = () => {
      if (grid.getAttribute('product-grid-view') !== 'default') {
        grid.setAttribute('product-grid-view', 'default');
      }

      try {
        sessionStorage.setItem('product-grid-view-desktop', 'default');
        sessionStorage.setItem('product-grid-view-mobile', 'default');
      } catch (_error) {
        // Session storage can be unavailable in some mobile contexts.
      }

      document.querySelectorAll('input[type="radio"][name="grid"]').forEach((option) => {
        option.checked = option.value === 'default';
      });
    };

    forceDefault();

    const gridViewObserver = new MutationObserver(forceDefault);
    gridViewObserver.observe(grid, { attributes: true, attributeFilter: ['product-grid-view'] });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name !== 'grid') return;
      window.setTimeout(forceDefault, 0);
    }, true);
  }

  function enhanceCards() {
    document.querySelectorAll('.alpha-card-actions').forEach((actions) => actions.remove());

    const cards = document.querySelectorAll('[data-alpha-product-card]:not(.alpha-ux-enhanced)');
    cards.forEach((card) => {
      card.classList.add('alpha-ux-enhanced');
      const product = readProduct(card);
      if (!product) return;
      syncCardState(card);

      card.addEventListener('touchstart', () => {
        card.classList.add('is-touch-active');
      }, { passive: true });
    });
  }

  /**
   * Shopify's pagination can occasionally re-insert a page after a rapid
   * filter/sort update. Keep the first occurrence of every product so the
   * collection never shows the same artwork more than once.
   */
  function removeDuplicateProducts(grid) {
    if (!(grid instanceof Element)) return;

    const seen = new Set();
    grid.querySelectorAll('.product-grid__item').forEach((item) => {
      const card = item.querySelector('[data-alpha-product-card]');
      const key =
        item.getAttribute('data-product-id') ||
        card?.getAttribute('data-alpha-product-id') ||
        card?.getAttribute('data-alpha-product-handle');

      if (!key) return;
      if (seen.has(key)) {
        item.remove();
        return;
      }
      seen.add(key);
    });
  }

  /**
   * Load every following collection page without relying on the theme's
   * one-shot sentinel. The original sentinel is removed so both loaders can
   * never request the same page at the same time.
   */
  function initResilientInfiniteScroll(resultsList, grid, bar) {
    if (resultsList.getAttribute('infinite-scroll') !== 'true') return;

    resultsList.querySelectorAll('[ref="viewMorePrevious"], [ref="viewMoreNext"]').forEach((anchor) => anchor.remove());
    resultsList.querySelectorAll('nav.pagination, .pagination').forEach((pagination) => pagination.remove());

    const lastPage = Number(grid.getAttribute('data-last-page')) || 1;
    let currentPage = Math.max(
      1,
      ...Array.from(grid.querySelectorAll('.product-grid__item[data-page]')).map((item) => Number(item.getAttribute('data-page')) || 1)
    );
    let loading = false;

    const sentinel = document.createElement('div');
    sentinel.className = 'alpha-infinite-sentinel';
    sentinel.setAttribute('data-alpha-infinite-sentinel', '');
    sentinel.innerHTML = `
      <span class="alpha-infinite-sentinel__spinner" aria-hidden="true"></span>
      <span class="alpha-infinite-sentinel__text">${escapeHtml(uiText.loadingMore)}</span>
    `;
    grid.insertAdjacentElement('afterend', sentinel);

    const finish = () => {
      observer.disconnect();
      sentinel.classList.add('is-complete');
      sentinel.innerHTML = `<span class="alpha-infinite-sentinel__complete">${escapeHtml(uiText.allDisplayed)}</span>`;
      updateCounter(bar, resultsList, grid);
    };

    const loadNextPage = async () => {
      if (loading || currentPage >= lastPage) {
        if (currentPage >= lastPage) finish();
        return;
      }

      loading = true;
      sentinel.classList.add('is-loading');
      resultsList.setAttribute('aria-busy', 'true');
      updateCounter(bar, resultsList, grid);

      const nextPage = currentPage + 1;
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('page', String(nextPage));

      try {
        const response = await fetch(nextUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`Collection page ${nextPage} unavailable`);

        const html = await response.text();
        const documentNext = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = documentNext.querySelector('.product-grid');
        if (!nextGrid) throw new Error(`Collection page ${nextPage} has no grid`);

        const existing = new Set(
          Array.from(grid.querySelectorAll('.product-grid__item')).map((item) =>
            item.getAttribute('data-product-id') ||
            item.querySelector('[data-alpha-product-card]')?.getAttribute('data-alpha-product-handle')
          ).filter(Boolean)
        );
        const fragment = document.createDocumentFragment();
        let appended = 0;

        nextGrid.querySelectorAll('.product-grid__item').forEach((item) => {
          const key =
            item.getAttribute('data-product-id') ||
            item.querySelector('[data-alpha-product-card]')?.getAttribute('data-alpha-product-handle');
          if (!key || existing.has(key)) return;
          existing.add(key);
          fragment.appendChild(document.importNode(item, true));
          appended += 1;
        });

        if (appended === 0) {
          throw new Error(`Collection page ${nextPage} contained no new products`);
        }

        grid.appendChild(fragment);
        currentPage = nextPage;
        removeDuplicateProducts(grid);

        if (currentPage >= lastPage) finish();
      } catch (_error) {
        sentinel.classList.add('has-error');
        sentinel.innerHTML = `<button class="alpha-infinite-sentinel__retry" type="button">${escapeHtml(uiText.retryLoading)}</button>`;
      } finally {
        loading = false;
        sentinel.classList.remove('is-loading');
        resultsList.removeAttribute('aria-busy');
        updateCounter(bar, resultsList, grid);
      }
    };

    const observer = new IntersectionObserver((entries) => {
      if (document.documentElement.hasAttribute('data-price-filter-active')) return;
      if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
    }, { rootMargin: '1200px 0px 1600px' });

    sentinel.addEventListener('click', (event) => {
      if (!event.target.closest('.alpha-infinite-sentinel__retry')) return;
      sentinel.classList.remove('has-error');
      sentinel.innerHTML = `
        <span class="alpha-infinite-sentinel__spinner" aria-hidden="true"></span>
        <span class="alpha-infinite-sentinel__text">${escapeHtml(uiText.loadingMore)}</span>
      `;
      loadNextPage();
    });

    if (currentPage >= lastPage) finish();
    else observer.observe(sentinel);
    resultsList.alphaPricePagination = {
      more: () => currentPage < lastPage,
      busy: () => loading,
      load: loadNextPage,
    };
  }

  function createQuickView() {
    const root = document.createElement('div');
    root.className = 'alpha-quick-view';
    root.hidden = true;
    root.innerHTML = `
      <section class="alpha-quick-view__panel" role="dialog" aria-modal="true" aria-label="${escapeAttr(uiText.productPreview)}">
        <button class="alpha-quick-view__close" type="button" aria-label="${escapeAttr(uiText.close)}">×</button>
        <div class="alpha-quick-view__image"><img alt="" data-alpha-quick-image></div>
        <div class="alpha-quick-view__content">
          <div class="alpha-quick-view__vendor" data-alpha-quick-vendor></div>
          <h2 class="alpha-quick-view__title" data-alpha-quick-title></h2>
          <div class="alpha-quick-view__price" data-alpha-quick-price></div>
          <div class="alpha-quick-view__buttons">
            <a class="alpha-quick-view__button" data-alpha-quick-link>${escapeHtml(uiText.view)}</a>
            <button class="alpha-quick-view__button alpha-quick-view__button--secondary" type="button" data-alpha-quick-slideshow>${escapeHtml(uiText.slideshowFromHere)}</button>
          </div>
        </div>
      </section>
    `;
    document.body.appendChild(root);
    return {
      root,
      close: root.querySelector('.alpha-quick-view__close'),
      image: root.querySelector('[data-alpha-quick-image]'),
      vendor: root.querySelector('[data-alpha-quick-vendor]'),
      title: root.querySelector('[data-alpha-quick-title]'),
      price: root.querySelector('[data-alpha-quick-price]'),
      link: root.querySelector('[data-alpha-quick-link]'),
      slideshow: root.querySelector('[data-alpha-quick-slideshow]'),
    };
  }

  function openQuickView(view, product) {
    view.image.src = sizedImage(product.image, 1200);
    view.image.alt = product.title || '';
    view.vendor.textContent = product.vendor || '';
    view.vendor.hidden = !product.vendor;
    view.title.textContent = product.title || '';
    view.price.textContent = product.price || '';
    view.price.hidden = !product.price;
    view.link.href = product.url || `/products/${product.handle}`;
    view.slideshow.onclick = () => {
      closeQuickView(view);
      openSlideshowAt(product.handle);
    };
    view.root.hidden = false;
    requestAnimationFrame(() => view.root.classList.add('is-open'));
    view.close.focus();
  }

  function closeQuickView(view) {
    view.root.classList.remove('is-open');
    window.setTimeout(() => {
      view.root.hidden = true;
    }, 160);
  }

  function createCompareDrawer() {
    const drawer = document.createElement('aside');
    drawer.className = 'alpha-compare-drawer';
    drawer.setAttribute('aria-label', uiText.compareArtworks);
    drawer.innerHTML = `
      <div class="alpha-compare-drawer__top">
        <div class="alpha-compare-drawer__title" data-alpha-compare-title>${escapeHtml(uiText.compare)}</div>
        <button class="alpha-compare-drawer__clear" type="button">${escapeHtml(uiText.clear)}</button>
      </div>
      <div class="alpha-compare-drawer__items" data-alpha-compare-items></div>
    `;
    document.body.appendChild(drawer);
    return {
      root: drawer,
      title: drawer.querySelector('[data-alpha-compare-title]'),
      clear: drawer.querySelector('.alpha-compare-drawer__clear'),
      items: drawer.querySelector('[data-alpha-compare-items]'),
    };
  }

  function renderCompare(drawer, state) {
    drawer.root.classList.toggle('is-open', state.compare.length > 0);
    drawer.title.textContent = `${state.compare.length} ${state.compare.length > 1 ? uiText.artworks : uiText.artwork} ${uiText.toCompare}`;
    drawer.items.innerHTML = state.compare.map((item) => `
      <article class="alpha-compare-item">
        <img src="${escapeAttr(sizedImage(item.image, 180))}" alt="${escapeAttr(item.title)}" loading="lazy">
        <div>
          <a class="alpha-compare-item__title" href="${escapeAttr(item.url)}">${escapeHtml(item.title)}</a>
          <div class="alpha-compare-item__price">${escapeHtml(item.price)}</div>
        </div>
        <button class="alpha-compare-item__remove" type="button" aria-label="${escapeAttr(uiText.remove)}" data-alpha-compare-remove="${escapeAttr(item.handle)}">×</button>
      </article>
    `).join('');
  }

  function toggleCompare(product, state) {
    const exists = state.compare.some((item) => item.handle === product.handle);
    if (exists) {
      state.compare = state.compare.filter((item) => item.handle !== product.handle);
    } else {
      state.compare = [product, ...state.compare].slice(0, 4);
    }
    saveList('alphaCollectionCompare:v1', state.compare);
  }

  function syncCardState(card) {
    const stateCompare = readList('alphaCollectionCompare:v1');
    const product = readProduct(card);
    if (!product) return;
    const compareButton = card.querySelector('[data-alpha-ux-action="compare"]');
    compareButton?.classList.toggle('is-active', stateCompare.some((item) => item.handle === product.handle));
  }

  function refreshCompareButtons(state) {
    document.querySelectorAll('[data-alpha-product-card]').forEach((card) => {
      const product = readProduct(card);
      const button = card.querySelector('[data-alpha-ux-action="compare"]');
      if (!product || !button) return;
      button.classList.toggle('is-active', state.compare.some((item) => item.handle === product.handle));
    });
  }

  function updateCounter(bar, resultsList, grid) {
    const target = bar?.querySelector('[data-alpha-collection-status]');
    if (!target) return;
    const total = Number(resultsList.getAttribute('data-alpha-collection-total')) || readTotalFromPage() || 0;
    const loaded = grid.querySelectorAll('.product-grid__item').length;
    const isLoading = Boolean(
      resultsList.matches('[loading], [aria-busy="true"], .loading') ||
      resultsList.querySelector('[data-loading-overlay], .loading, [aria-busy="true"]')
    );
    const hasMore = total > loaded;

    bar?.classList.toggle('is-loading', isLoading);
    bar?.classList.toggle('is-complete', !hasMore);
    target.innerHTML = `
      <span class="alpha-collection-ux__pulse" aria-hidden="true"></span>
      <span><strong>${loaded}</strong> ${escapeHtml(uiText.of)} ${total || loaded} ${escapeHtml((total || loaded) === 1 ? uiText.artwork : uiText.artworks)}</span>
      <span class="alpha-collection-ux__loading-copy">${escapeHtml(isLoading ? uiText.loading : hasMore ? uiText.scrollForMore : uiText.allDisplayed)}</span>
    `;
  }

  function createResumeButton(resumeKey) {
    const data = readResume(resumeKey);
    if (!data) return null;
    const button = document.createElement('button');
    button.className = 'alpha-resume-button';
    button.type = 'button';
    button.textContent = uiText.resume;
    document.body.appendChild(button);
    return button;
  }

  function wireResumeStorage(resumeKey) {
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const link = target.closest('a[href*="/products/"]');
      const card = link?.closest('[data-alpha-product-card]');
      const product = readProduct(card);
      if (!product) return;
      localStorage.setItem(resumeKey, JSON.stringify({
        handle: product.handle,
        scrollY: window.scrollY,
        title: product.title,
        time: Date.now(),
      }));
    }, true);
  }

  function observePreloadWindow(state) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const card = entry.target;
        const cards = Array.from(document.querySelectorAll('[data-alpha-product-card]'));
        const index = cards.indexOf(card);
        preloadAround(cards, index, state);
      });
    }, { rootMargin: '1200px 0px 1600px' });

    document.querySelectorAll('[data-alpha-product-card]').forEach((card) => {
      card.setAttribute('data-alpha-preload-observed', 'true');
      observer.observe(card);
    });

    const grid = document.querySelector('.product-grid');
    if (grid) {
      new MutationObserver(() => {
        document.querySelectorAll('[data-alpha-product-card]:not([data-alpha-preload-observed])').forEach((card) => {
          card.setAttribute('data-alpha-preload-observed', 'true');
          observer.observe(card);
        });
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  function preloadAround(cards, index, state) {
    if (index < 0) return;
    const start = Math.max(0, index - 4);
    const end = Math.min(cards.length, index + 41);
    for (let i = start; i < end; i += 1) {
      const product = readProduct(cards[i]);
      if (!product?.image) continue;
      const src = sizedImage(product.image, window.innerWidth < 700 ? 520 : 760);
      if (state.preloaded.has(src)) continue;
      state.preloaded.add(src);
      const image = new Image();
      image.decoding = 'async';
      image.loading = i <= index + 6 ? 'eager' : 'lazy';
      image.src = src;
    }
  }

  function markLoadedImages() {
    document.querySelectorAll('[data-alpha-product-card]').forEach((card) => {
      const image = card.querySelector('img');
      if (!image) return;
      const markLoaded = () => {
        card.classList.add('is-image-loaded');
        markOrientation(card, image);
      };
      if (image.complete && image.naturalWidth > 0) markLoaded();
      image.addEventListener('load', markLoaded, { once: true });
    });
  }

  function markOrientation(card, image) {
    const width = image.naturalWidth || 1;
    const height = image.naturalHeight || 1;
    const ratio = width / height;
    let orientation = 'square';
    if (ratio > 1.12) orientation = 'landscape';
    if (ratio < 0.88) orientation = 'portrait';
    card.setAttribute('data-alpha-orientation', orientation);
  }

  function openSlideshowAt(handle) {
    document.dispatchEvent(new CustomEvent('alpha:openCollectionSlideshowAt', { detail: { handle } }));
  }

  function readProduct(card) {
    if (!(card instanceof Element)) return null;
    const handle = card.getAttribute('data-alpha-product-handle') || handleFromUrl(card.getAttribute('data-alpha-product-url'));
    if (!handle) return null;
    const image = card.getAttribute('data-alpha-product-image') || card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '';
    return {
      id: card.getAttribute('data-alpha-product-id') || handle,
      handle,
      url: card.getAttribute('data-alpha-product-url') || `/products/${handle}`,
      title: card.getAttribute('data-alpha-product-title') || card.querySelector('.alpha-product-card__title')?.textContent?.trim() || '',
      vendor: card.getAttribute('data-alpha-product-vendor') || card.querySelector('.alpha-product-card__artist')?.textContent?.trim() || '',
      price: card.getAttribute('data-alpha-product-price') || card.querySelector('.alpha-product-card__price')?.textContent?.replace(/\s+/g, ' ').trim() || '',
      image,
    };
  }

  function findCardByHandle(handle) {
    return Array.from(document.querySelectorAll('[data-alpha-product-card]'))
      .find((card) => card.getAttribute('data-alpha-product-handle') === handle);
  }

  function readResume(key) {
    try {
      const data = JSON.parse(localStorage.getItem(key) || 'null');
      if (!data || Date.now() - data.time > 1000 * 60 * 60 * 24 * 7) return null;
      return data;
    } catch (_error) {
      return null;
    }
  }

  function readList(key) {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_error) {
      return [];
    }
  }

  function saveList(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_error) {
      // Storage can be unavailable in private or restricted mobile contexts.
    }
  }

  function readTotalFromPage() {
    const text = document.body.textContent || '';
    const match = text.match(/(\d[\d\s.,]*)\s*(?:œuvres|oeuvres|produits|products)\b/i);
    return match ? Number(match[1].replace(/[^\d]/g, '')) : 0;
  }

  function handleFromUrl(url) {
    if (!url) return '';
    try {
      return decodeURIComponent(new URL(url, window.location.origin).pathname.match(/\/products\/([^/?#]+)/)?.[1] || '');
    } catch (_error) {
      return '';
    }
  }

  function sizedImage(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      if (url.pathname.includes('/cdn/shop/') || url.hostname.includes('shopify')) {
        url.searchParams.set('width', String(width));
      }
      return url.toString();
    } catch (_error) {
      return src;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }
})();
